import { forwardRef, useMemo } from 'react'
import moment, { Moment } from 'moment'
import {
  TimePicker as BaseTimePicker,
  TimePickerProps as BaseProps,
} from 'antd'

export interface TimePickerProps
  extends Omit<
    BaseProps,
    | 'value'
    | 'defaultValue'
    | 'format'
    | 'hourStep'
    | 'minuteStep'
    | 'secondStep'
    | 'locale'
    | 'mode'
  > {
  value?: string | Moment
  defaultValue?: string | Moment
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const TimePicker = forwardRef<any, TimePickerProps>(
  ({ value, defaultValue, ...rest }, ref): JSX.Element => {
    const castValue = useMemo<BaseProps['value']>(() => {
      if (value instanceof moment) {
        return value as Moment
      } else if (typeof value === 'string' && value !== '') {
        return moment(value, 'HH:mm')
      } else {
        return undefined
      }
    }, [value])

    const castDefaultValue = useMemo<BaseProps['value']>(() => {
      if (defaultValue instanceof moment) {
        return defaultValue as Moment
      } else if (typeof defaultValue === 'string' && defaultValue !== '') {
        return moment(defaultValue, 'HH:mm')
      } else {
        return undefined
      }
    }, [defaultValue])

    return (
      <>
        <BaseTimePicker
          format={'HH:mm'}
          ref={ref}
          minuteStep={10}
          value={castValue}
          defaultValue={castDefaultValue}
          {...rest}
        />
      </>
    )
  }
)

export default TimePicker
